export default __webpack_public_path__ + "atomic/_patterns/02-molecules/card-simple/_card-simple.twig";